// Active-subscription Query (single owner of server-state per STATE_POLICY).
// The hook itself lives in `subscription.selectors.ts` (auth dependency); this
// module re-exports the non-React snapshot helper + types.
export {
  getActiveSubscriptionSnapshot,
  ACTIVE_SUBSCRIPTION_DEFAULT,
  type ActiveSubscriptionData,
  type EffectivePlan,
  type Usage,
} from './active-subscription.query';

// Tiny UI store for subscription notifications (client-only toasts)
export {
  useSubscriptionNotificationsStore,
  type SubscriptionNotification,
} from './subscription-notifications.store';

// Selector exports
export {
  useActiveSubscription,
  useSubscription,
  usePlan,
  useUsage,
  useIsGuestMode,
  useEffectivePlan,
  useTokenBalance,
  useTokenBalanceInitialized,
  useSubscriptionLoading,
  useSubscriptionError,
  useSubscriptionNotifications,
  useIsDataLoaded,
  useRemainingTokens,
  useSubscriptionLimits,
  useSubscriptionStatus,
  useSubscriptionActions,
  useHasFeature,
  useIsSubscriptionActive,
  useCheckLimit,
  useNeedsUpgrade,
  usePaywallPayload,
  usePaywallPayloads,
  computeLimits,
  type SubscriptionLimits,
} from './subscription.selectors';

// Per-building effective feature flags (Facade Pack pivot) — gate render/album
// toggles on the building's resolved features, not just the user plan.
export {
  useProjectFeatures,
  type ProjectFeatures,
} from './project-features';
